import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

function SimpleInfoBoxServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);

    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper
          Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
          Image="theme-2-banner-speciality.webp"
        />


        <div className="container">
             {sitedata?.site_type === "hospitals" ? (
            <div className="row mt-5">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title mb-0 text-uppercase">
                      Provides Our{" "}
                      <span className="theme-color">Best Specialties</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5"></div>
          )}

          <div className="row my-3">
            {isLoading ? (
              <div className="col-12 text-center">
                <Spinner />
              </div>
            ) : isData ? (
              <div className="col-12 text-center mb-4">
                <h4>No Record Available</h4>
              </div>
            ) : (
              servicesData.map((service, index) => (
                <div className="col-lg-4 item mb-5" key={index}>
                  <div className="item animated fadeInDown visible" key={index}>
                    <div className="service-box-wrap service-box-style-1 duo-box-home-height">
                      <div className="service-box-inner h-100">
                        <div
                          className="service-thumb mb-4 new-fservices-img-wrapper"
                          style={{
                            backgroundImage: `url(${service?.service_image_url})`,
                          }}
                        ></div>
                        <div className="service-content">
                          <h3 className="service-title mb-2 new-fservices-title-wrapper">
                            {service?.service_title}
                          </h3>
                          <div
                            className="service-desc mb-4"
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(service?.service_short_description, 95) +
                                (service?.service_short_description?.length > 95 ? "..." : ""),
                            }}
                          />
                          <div className="service-link">
                            <Link
                              to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                .replaceAll(" ", "-")
                                .replaceAll("/", "-")}`}
                              rel="noopener noreferrer"
                              className="btn btn-default link"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default SimpleInfoBoxServicesListing;
